import { render, staticRenderFns } from "./ExpedicaoModalPagamentoTarget.vue?vue&type=template&id=4a718448"
import script from "./ExpedicaoModalPagamentoTarget.vue?vue&type=script&lang=js"
export * from "./ExpedicaoModalPagamentoTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports